import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type { ISingleTabDefinition } from '../documentManagement/SingleTab.definition';
import type { ISingleTabMapperProps } from '../SingleTab.types';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import { FIX_BACKGROUND_SPEC } from '../../Tabs/constants';

export const props = withCompInfo<
  ISingleTabMapperProps,
  ISingleTabDefinition,
  ISingleTabMapperProps
>()(
  ['compData', 'compMeshProps', 'hasResponsiveLayout'],
  ({ compData, compMeshProps, hasResponsiveLayout }, carmiData) => {
    return {
      ...carmiData,
      ...compData,
      meshProps: compMeshProps,
      hasResponsiveLayout,
    };
  },
);

const css = withCompInfo()(
  ['hasResponsiveLayout', 'styleProperties', 'experiments'],
  ({ hasResponsiveLayout, styleProperties, experiments }) => {
    const isFixedGradiantBackground = isExperimentOpen(
      experiments,
      FIX_BACKGROUND_SPEC,
    );
    const { 'bg-gradient': bgGradiant } = styleProperties;
    return {
      width: '100%',
      // Prevents Tabs display variable from affecting elements inside SingleTab
      '--display': 'initial',
      ...(hasResponsiveLayout ? {} : { height: 'auto' }),
      '--bg-gradient': isFixedGradiantBackground ? 'none' : bgGradiant,
    };
  },
);

export default createComponentMapperModel({
  props,
  css,
});
